export {Slider} from './slider.class'
export {CraftVue} from './craft-vue.class'


// WEBPACK FOOTER //
// ./scripts/starters/index.js